import React from 'react'

const BienvenidoCliente = ({
    identificacion
}) => {
  return (
    <div className='pt-4'>
           <h5
                   className='fw-bold pt-2'
                   style={{
                     color: '#3a3a3a !important'
                   }}
                 >
                   Bienvenido {identificacion.nombre}
                 </h5>
                 <p
                   className='text-muted fw-bold text-left p-0 m-0'
                   style={{ fontSize: '15px' }}
                 >
                   Indicaciones:
          </p>
        <ul>
            <li className='text-muted text-left p-0 m-0' style={{ fontSize: '14px' }}>
              Los pagos seleccionados deben ser iguales o superiores a $3.00
            </li>
         </ul>
    </div>
  )
}

export default BienvenidoCliente